<!--
 * @Author: linsc
 * @Date: 2023-04-04 10:47:45
 * @LastEditTime: 2023-04-13 16:01:42
 * @LastEditors: Please set LastEditors
 * @Description: 上传表单
 * @FilePath: \kcop-smcr\src\business\businessFile\GUOXIN\M0002\QS421_uploadImg.vue
-->
<template>
  <div class="QS421-upload-img-page">
      <img-collect-list nodeKey="appvTask2" imgType="uploadForm" ref ="uploadForm" qrCodeType="4" :isShowNav="true" :bizData.sync = 'bizData' :historyData = "historyData" :oppBusiData = "oppBusiData" 
      :maxApptStatus="12" :isDisabled="isDisablePage"
      @on-next-click="next"></img-collect-list >
  </div>
</template>

<script>

import imgCollectList from "@/components/imageNode/imgCollectList.vue";


export default {
  data () {
    return {
            
    };
  },
  components: {
    imgCollectList
  },
  props: ["bizData", "historyData", "oppBusiData", "groupDatas", "busiCode","isDisablePage"],
  mounted () {

  },
  beforeDestroy (){
    this.$emit("remove-flow-tip", "M0002SignDownLoad");
  },
  methods: {
    pageActivated (_this){
      _this.hideFooter(false);
    },
    validate (_this) {
      let that = _this.$refs.QS421_uploadForm;
      return that.$refs.uploadForm.validate().then(flag=>{
        return flag;
      });
    },
    //下一步时，保存数据.
    beforeSave (_this, params, baseData) {
      // let that = _this.$refs.QS421_uploadImg;
      // let SIGN_INFO =  that.$refs.uploadImgView.getData() ;

      // if(_.isEmpty(params.SIGN_INFO)){
      //     params.SIGN_INFO = {};
      // }
      // Object.assign(params, {
      //     SIGN_INFO: SIGN_INFO
      // });
    },
    next () {
      this.$emit("on-next-click");
    }
  }
    

};
</script>

<style lang="less" scoped>
    .M0002-sign-download-page {
        width: 1000px;
        height: 750px;
        overflow-x: hidden;
        padding-right: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/business/businessFile/QS421/QS421_uploadForm.vue